/* Created by Interactive 63 - https://interactive63.com */
/**
 * The Preview dialog: runs the real HTML export in a sandboxed iframe, with controls for
 * background, width, simulated reduced motion and how many times the scene repeats.
 */
import type { Store } from '../store/store';
import { h } from '../ui/dom';
import { PreviewFrame } from './preview-frame';

export class PreviewDialog {
  private readonly dialog: HTMLDialogElement;
  private readonly frame: PreviewFrame;

  /** Creates the dialog and attaches it to the page. */
  constructor(store: Store) {
    this.frame = new PreviewFrame(store);
    const close = h('button', { type: 'button' }, 'Close');
    close.addEventListener('click', () => {
      this.dialog.close();
    });
    this.dialog = h(
      'dialog',
      { class: 'large-dialog preview-dialog', 'aria-label': 'Preview' },
      h('header', { class: 'dialog-header' }, h('h3', null, 'Preview'), close),
      this.frame.el,
    );
    document.body.append(this.dialog);
  }

  /** Opens the dialog and starts the animation. */
  open(): void {
    if (!this.dialog.open) this.dialog.showModal();
    this.frame.refresh();
  }
}
